import { Component, Input } from '@angular/core';

import { VideoService } from 'rev-shared/media/Video.Service';
import { VideoStatus } from 'rev-shared/media/VideoStatus';

@Component({
	selector: 'video-playback-status-msg',
	templateUrl: './VideoPlaybackStatusMsg.Component.html'
})

export default class VideoPlaybackStatusMsgComponent {
	@Input() public pageStatus: any;
	@Input() public playableStatus: string;
	@Input() public showRestoreBtn: boolean;
	@Input() private videoId: string;

	public readonly VideoStatus = VideoStatus;

	constructor(
		private VideoService: VideoService
	) { }

	public onRevert(): void {
		this.playableStatus = this.VideoStatus.PROCESSING;
		this.VideoService.revertVideo(this.videoId);
	}
}
